import React from 'react'
import WeatherDashboardimage from "./weatherDashboard.jpg"

export default function Weatherdasboard() {
  return (
    <img className ="w-64 m-auto rounded-lg hover:w-96 hover:ease-in duration-300" src={WeatherDashboardimage}></img>
  )
}
